module.exports = __webpack_public_path__ + "static/media/100- desktop-work-desk-planner.36e971c6.png";